import React, { useState } from 'react'
import styles from '../../sass/dashboard.module.scss'
import { Icons } from '../../constant'

const Dashboard = () => {
  const time = new Date().toLocaleTimeString();
  const tabs = ['All time', '12 Months', '30 Days', '7 Days', '24 Hours'];
  const [activeTab, setActiveTab] = useState('All time');

  return (
    <div className={styles.Home_mainWrapper}>
      <div className={styles.Home_headerContainer}>
        <div className={styles.Home_header_LHS_wrapper}>
          <div className={styles.title}>Monitor the health of <br/>the business</div>
          <span className={styles.supportingTxt}>Control and analyze the data in the easiest way.</span>
        </div>
        <div className={styles.Home_header_RHS_wrapper}>
          <span className={styles.overviewTxt}>#STORE-OVERVIEW</span>
          <div className={styles.overviewUpdate}><span><span className={styles.overviewUTxt}>Update:</span> {time}</span> <img src={Icons.sync} onClick={() => window.location.reload()} alt='sync' className={styles.sync} /></div>
        </div>
      </div>
      {/* /Home_headerContainer */}

      <div className={styles.Home_CardFilters_wrapper}>
        <div className={styles.Home_TabFilters_wrapper}>
          <div className={styles.Home_TabFilters_LHS_wrapper}>
            {tabs.map((tab) => (
              <div key={tab} className={`${styles.tabItem} ${activeTab === tab ? styles.activeTab : ''}`} onClick={() => setActiveTab(tab)}>
                {tab}
              </div>
            ))}
          </div>
          <div className={styles.Home_TabFilters_RHS_wrapper}>
            <div className={styles.rangeSelector}>
              <img src={Icons.calendar} alt='calendar' />
              <span>Select date</span>
            </div>
            <div className={styles.actionBtn}>+ Add new order</div>
          </div>
        </div>
      </div>
      {/* /Home_CardFilters_wrapper */}

      <section className={styles.Section1_wrapper}>
        <div className={styles.Section1_LHS_wrapper}>
          <div className={styles.Section1_cards_wrapper}>
            <div className={styles.Section1_card_wrapper}>
              <div className={styles.Section1_cardHeader}>
                <img src={Icons.oprovided} alt='oprovided' />
                <span className={styles.title}>Orders Provided</span>
              </div>
              <div className={styles.Section1_cardBody}>
                <div className={styles.colItems}>
                  <div className={styles.item}>
                    <span className={styles.title}>210</span>
                    <span className={styles.support}>Processing</span>
                  </div>
                  <div className={styles.item}>
                    <span className={styles.title}>109</span>
                    <span className={styles.support}>Processed</span>
                  </div>
                  <div className={styles.item}>
                    <span className={styles.title}>15</span>
                    <span className={styles.support}>Canceled</span>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.Section1_card_wrapper}>
              <div className={styles.Section1_cardHeader}>
                <img src={Icons.odispatched} alt='odispatched' />
                <span className={styles.title}>Orders Dispatched</span>
              </div>
              <div className={styles.Section1_cardBody}>
                <div className={styles.colItems}>
                  <div className={styles.item}>
                    <span className={styles.title}>256</span>
                    <span className={styles.support}>Total</span>
                  </div>
                  <div className={styles.item}>
                    <span className={styles.title}>49</span>
                    <span className={styles.support}>Return (RTO)</span>
                  </div>
                  <div className={styles.item}>
                    <span className={styles.title}>193</span>
                    <span className={styles.support}>Completed</span>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.Section1_card_wrapper}>
              <div className={styles.Section1_cardHeader}>
                <img src={Icons.orders} alt='orders' />
                <span className={styles.title}>Orders</span>
              </div>
              <div className={styles.Section1_cardBody}>
                <div className={styles.colItems}>
                  <div className={styles.item}>
                    <span className={styles.title}>1269</span>
                    <span className={styles.support}>Total</span>
                  </div>
                  <div className={styles.item}>
                    <span className={styles.title}>158</span>
                    <span className={styles.support}>Today</span>
                  </div>
                  <div className={styles.item}>
                    <span className={styles.title}>256</span>
                    <span className={styles.support}>Yesterday</span>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.Section1_card_wrapper}>
              <div className={styles.Section1_cardHeader}>
                <img src={Icons.acart} alt='acart' />
                <span className={styles.title}>Abandoned Cart</span>
              </div>
              <div className={styles.Section1_cardBody}>
                <div className={styles.colItems}>
                  <div className={styles.item}>
                    <span className={styles.title}>120</span>
                    <span className={styles.support}>Total</span>
                  </div>
                  <div className={styles.item}>
                    <span className={styles.title}>86</span>
                    <span className={styles.support}>Today</span>
                  </div>
                  <div className={styles.item}>
                    <span className={styles.title}>39</span>
                    <span className={styles.support}>Yesterday</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.Section1_RHS_wrapper}>
          <div className={styles.Section1_card_wrapper}>
            <div className={styles.Section1_cardHeader}>
              <img src={Icons.mapcircle} alt='mapcircle' />
              <span className={styles.title}>Top 5 states</span>
            </div>
            <div className={styles.Section1_cardBody}>
              <div className={styles.rowItems}>
                <div className={styles.item}>
                  <span className={styles.name}>Maharashtra</span>
                  <div className={styles.wrapper}>
                    <span className={styles.amount}>₹5,20,000</span>
                    <span className={styles.orders}>Orders <span className={styles.value}>259</span></span>
                  </div>
                </div>
                <div className={styles.item}>
                  <span className={styles.name}>Tamil Nadu</span>
                  <div className={styles.wrapper}>
                    <span className={styles.amount}>₹4,00,000</span>
                    <span className={styles.orders}>Orders <span className={styles.value}>220</span></span>
                  </div>
                </div>
                <div className={styles.item}>
                  <span className={styles.name}>Karnataka</span>
                  <div className={styles.wrapper}>
                    <span className={styles.amount}>₹3,80,000</span>
                    <span className={styles.orders}>Orders <span className={styles.value}>180</span></span>
                  </div>
                </div>
                <div className={styles.item}>
                  <span className={styles.name}>Punjab</span>
                  <div className={styles.wrapper}>
                    <span className={styles.amount}>₹2,40,000</span>
                    <span className={styles.orders}>Orders <span className={styles.value}>120</span></span>
                  </div>
                </div>
                <div className={styles.item}>
                  <span className={styles.name}>Uttar Pradesh</span>
                  <div className={styles.wrapper}>
                    <span className={styles.amount}>₹1,45,000</span>
                    <span className={styles.orders}>Orders <span className={styles.value}>90</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
export default Dashboard